// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.7.7
//   protoc               unknown
// source: qonto/spend_management/memberships/memberships/firstparty/v3/get_aggregate_membership.proto

/* eslint-disable */

/** Enum for the KYC status. */
export const ApiKycStatus = {
  /** KYC_STATUS_UNSPECIFIED - unspecified status. */
  KYC_STATUS_UNSPECIFIED: "KYC_STATUS_UNSPECIFIED",
  /**
   * pending - The KYC status is pending.
   */
  pending: "pending",
  /**
   * accepted - The KYC status is accepted.
   */
  accepted: "accepted",
  /**
   * refused - The KYC status is refused.
   */
  refused: "refused",
} as const;

export type ApiKycStatus = typeof ApiKycStatus[keyof typeof ApiKycStatus];

export namespace ApiKycStatus {
  export type KYC_STATUS_UNSPECIFIED = typeof ApiKycStatus.KYC_STATUS_UNSPECIFIED;
  export type pending = typeof ApiKycStatus.pending;
  export type accepted = typeof ApiKycStatus.accepted;
  export type refused = typeof ApiKycStatus.refused;
}

export function apiKycStatusFromJSON(object: any): ApiKycStatus {
  switch (object) {
    case 0:
    case "KYC_STATUS_UNSPECIFIED":
      return ApiKycStatus.KYC_STATUS_UNSPECIFIED;
    case 1:
    case "pending":
      return ApiKycStatus.pending;
    case 2:
    case "accepted":
      return ApiKycStatus.accepted;
    case 3:
    case "refused":
      return ApiKycStatus.refused;
    default:
      return ApiKycStatus.KYC_STATUS_UNSPECIFIED;
  }
}

export function apiKycStatusToJSON(object: ApiKycStatus): string {
  switch (object) {
    case ApiKycStatus.KYC_STATUS_UNSPECIFIED:
      return "KYC_STATUS_UNSPECIFIED";
    case ApiKycStatus.pending:
      return "pending";
    case ApiKycStatus.accepted:
      return "accepted";
    case ApiKycStatus.refused:
      return "refused";
    default:
      return "KYC_STATUS_UNSPECIFIED";
  }
}

/** Message for an aggregate membership. */
export interface ApiAggregateMembership {
  /** The membership id. */
  readonly id: string;
  /** The identity id. */
  readonly identityId: string;
  /** The KYC status. */
  readonly kycStatus: ApiKycStatus;
  /** The onboarded card. */
  readonly onboardedCard: boolean;
  /** The features. */
  readonly features: readonly string[];
  /** The topups status. */
  readonly topupsStatus: string;
  /** The corporate officer. */
  readonly corporateOfficer: boolean;
  /** The UBO. */
  readonly ubo: boolean;
  /** The KYC required. */
  readonly kycRequired: boolean;
  /** The KYC submitted. */
  readonly kycSubmitted: boolean;
  /** The personal info provided. */
  readonly personalInfoProvided: boolean;
}

/** empty Request message for getting an aggregate membership. */
export interface ApiGetAggregateMembershipRequest {
}

/** Response message for getting an aggregate membership. */
export interface ApiGetAggregateMembershipResponse {
  /** The aggregate membership. */
  readonly membership: ApiAggregateMembership | null;
}

export const ApiAggregateMembership: MessageFns<ApiAggregateMembership> = {
  fromJSON(object: any): ApiAggregateMembership {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      identityId: isSet(object.identity_id) ? globalThis.String(object.identity_id) : "",
      kycStatus: isSet(object.kyc_status)
        ? apiKycStatusFromJSON(object.kyc_status)
        : ApiKycStatus.KYC_STATUS_UNSPECIFIED,
      onboardedCard: isSet(object.onboarded_card) ? globalThis.Boolean(object.onboarded_card) : false,
      features: globalThis.Array.isArray(object?.features) ? object.features.map((e: any) => globalThis.String(e)) : [],
      topupsStatus: isSet(object.topups_status) ? globalThis.String(object.topups_status) : "",
      corporateOfficer: isSet(object.corporate_officer) ? globalThis.Boolean(object.corporate_officer) : false,
      ubo: isSet(object.ubo) ? globalThis.Boolean(object.ubo) : false,
      kycRequired: isSet(object.kyc_required) ? globalThis.Boolean(object.kyc_required) : false,
      kycSubmitted: isSet(object.kyc_submitted) ? globalThis.Boolean(object.kyc_submitted) : false,
      personalInfoProvided: isSet(object.personal_info_provided)
        ? globalThis.Boolean(object.personal_info_provided)
        : false,
    };
  },

  toJSON(message: ApiAggregateMembership): unknown {
    const obj: any = {};
    if (message.id !== undefined && message.id !== null) {
      obj.id = message.id;
    }
    if (message.identityId !== undefined && message.identityId !== null) {
      obj.identity_id = message.identityId;
    }
    if (message.kycStatus !== undefined && message.kycStatus !== null) {
      obj.kyc_status = apiKycStatusToJSON(message.kycStatus);
    }
    if (message.onboardedCard !== undefined && message.onboardedCard !== null) {
      obj.onboarded_card = message.onboardedCard;
    }
    if (message.features?.length) {
      obj.features = message.features;
    }
    if (message.topupsStatus !== undefined && message.topupsStatus !== null) {
      obj.topups_status = message.topupsStatus;
    }
    if (message.corporateOfficer !== undefined && message.corporateOfficer !== null) {
      obj.corporate_officer = message.corporateOfficer;
    }
    if (message.ubo !== undefined && message.ubo !== null) {
      obj.ubo = message.ubo;
    }
    if (message.kycRequired !== undefined && message.kycRequired !== null) {
      obj.kyc_required = message.kycRequired;
    }
    if (message.kycSubmitted !== undefined && message.kycSubmitted !== null) {
      obj.kyc_submitted = message.kycSubmitted;
    }
    if (message.personalInfoProvided !== undefined && message.personalInfoProvided !== null) {
      obj.personal_info_provided = message.personalInfoProvided;
    }
    return obj;
  },
};

export const ApiGetAggregateMembershipRequest: MessageFns<ApiGetAggregateMembershipRequest> = {
  fromJSON(_: any): ApiGetAggregateMembershipRequest {
    return {};
  },

  toJSON(_: ApiGetAggregateMembershipRequest): unknown {
    const obj: any = {};
    return obj;
  },
};

export const ApiGetAggregateMembershipResponse: MessageFns<ApiGetAggregateMembershipResponse> = {
  fromJSON(object: any): ApiGetAggregateMembershipResponse {
    return { membership: isSet(object.membership) ? ApiAggregateMembership.fromJSON(object.membership) : null };
  },

  toJSON(message: ApiGetAggregateMembershipResponse): unknown {
    const obj: any = {};
    if (message.membership !== undefined && message.membership !== null) {
      obj.membership = ApiAggregateMembership.toJSON(message.membership);
    }
    return obj;
  },
};

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

interface MessageFns<T> {
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
}
